import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import axios from "axios";

const getAuthHeader = () => ({
  Authorization: `Bearer ${sessionStorage.getItem("usr_1a2b3c")}`,
});

export const fetchImagingEarningsSummary = createAsyncThunk(
  "imagingEarnings/fetchSummary",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + APP_PATH.imagingEarningsSummary,
        { headers: getAuthHeader(), params },
      );
      return response.data?.data || {};
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchImagingEarningsList = createAsyncThunk(
  "imagingEarnings/fetchList",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + APP_PATH.imagingEarnings,
        { headers: getAuthHeader(), params },
      );
      return response.data?.data || { earnings: [], pagination: {} };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const exportImagingEarnings = createAsyncThunk(
  "imagingEarnings/export",
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + APP_PATH.imagingEarningsExport,
        { headers: getAuthHeader(), params },
      );
      return response.data?.data || {};
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
